import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const StyledContainer = styled(FlexContainer)({
  flexDirection: "column",
  gap: "20px",
})

export const StyledPeriodicityContainer = styled(FlexContainer)({
  gap: "10px",
})
